// import dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import images
import tollfree from '~/common/images/toll-free-icon.svg';
import local from '~/common/images/map-pin-icon.svg';

// import stylesheet
import btnStyles from '~/common/components/CommonButton/common-button.css';
import styles from './contentBox.css';

const LinkBox = ({ to, type, id, dataTest, onClickCall }) => {
    const content = {
        'Toll Free': {
            header: 'Toll Free',
            imgSrc: tollfree,
            imgAlt: 'tollfree badge',
            text: 'Look bigger, national, and more established; customize a number, or let us generate one.',
            linkTxt: 'Get a Toll Free Number'
        },
        Local: {
            header: 'Local',
            imgSrc: local,
            imgAlt: 'local badge',
            text: 'Connect with your community by choosing a number with a local area code.',
            linkTxt: 'Get a Local Number'
        }
    };
    return (
        <div
            className={styles.linkbox}
            data-test={dataTest}
            id={id}
            to={to}
            {...onClickCall && { onClick: onClickCall }}
        >
            <h1 className={styles.header}>
                {content[type].header}
            </h1>
            {content[type]?.imgSrc ?
                <img
                    alt={content[type].imgAlt}
                    className={styles.image}
                    src={content[type].imgSrc}
                />
                :
                null
            }
            <p className={styles.text}>
                {content[type].text}
            </p>
            <Link
                className={`${btnStyles.button} ${styles.link}`}
                data-test={dataTest}
                id={id}
                to={to}
                {...onClickCall && { onClick: onClickCall }}
            >
                {content[type].linkTxt}
            </Link>
        </div>
    );
};

LinkBox.propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.string,
    figure: PropTypes.string
};

export default LinkBox;
